<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Dashboard</h3>
            </d-col>
        </d-row>

        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <!-- Small Stats Blocks -->
            <d-row v-if="fetched">
                <d-col lg v-for="(stats, idx) in smallStats" :key="idx" class="mb-4">
                    <small-stats
                            :id="`small-stats-${idx}`"
                            variation="1"
                            :chart-data="stats.datasets"
                            :label="stats.label"
                            :value="stats.value"
                            :percentage="stats.percentage"
                            :increase="stats.increase"
                            :decrease="stats.decrease" />
                </d-col>
            </d-row>
        </transition>

        <transition name="fade">
            <div  v-show="fetched">
                <d-row>
                    <!-- Users Overview -->
                    <d-col lg="12" md="12" sm="12" class="mb-4">
                        <d-card class="card-small h-100">
                            <d-card-header class="border-bottom">
                                <h6 class="m-0">Nadchodzące płatności</h6>
                                <div class="block-handle"></div>
                            </d-card-header>
                            <installments-list class="overflow-auto-dashboard" :props="upcoming_installments" @updateData="loadUpcomingPayments" />
                        </d-card>
                    </d-col>
                </d-row>
                <d-row>
                    <d-col lg="12" md="12" sm="12" class="mb-4">
                        <d-card class="card-small h-100">
                            <d-card-header class="border-bottom">
                                <h6 class="m-0">Kończące się umowy</h6>
                                <div class="block-handle"></div>
                            </d-card-header>
                            <schedules-ending class="overflow-auto-dashboard" :props="schedules_about_to_end" @updateData="loadSchedulesAboutToEnd" />
                        </d-card>
                    </d-col>
                </d-row>
                <d-row>
                    <d-col lg="12" md="12" sm="12" class="mb-4">
                        <d-card class="card-small h-100">
                            <d-card-header class="border-bottom">
                                <h6 class="m-0">Umowy wymagające operacji na zabezpieczeniach</h6>
                                <div class="block-handle"></div>
                            </d-card-header>
                            <guarantees-to-update :props="schedules_guarantees_to_update" class="overflow-auto-dashboard"  />
                        </d-card>
                    </d-col>
                </d-row>
                <d-row>
                    <d-col lg="12" md="12" sm="12" class="mb-4">
                        <d-card class="card-small h-100">
                            <d-card-header class="border-bottom">
                                <h6 class="m-0">Umowy z niepełnymi dyspozycjami</h6>
                                <div class="block-handle"></div>
                            </d-card-header>
                            <schedules-ending class="overflow-auto-dashboard" :props="schedules_incomplete_instructions" @updateData="loadSchedulesIncompleteInstructions" />
                        </d-card>
                    </d-col>
                </d-row>
            </div>

        </transition>
    </d-container>
</template>

<script>
/* eslint-disable */
    import SmallStats from '@/components/common/SmallStats.vue';
    import PieChart from '@/components/dashboard/PieChart';
    import SchedulesEnding from '@/components/dashboard/SchedulesEnding';
    import InstallmentsList from "../components/dashboard/InstallmentsList";
    import GuaranteesToUpdate from "../components/dashboard/GuaranteesToUpdate";

    export default {
        name: 'Dashboard',
        components: {
            InstallmentsList,
            SmallStats,
            PieChart,
            SchedulesEnding,
            GuaranteesToUpdate
        },
        data() {
            return {
                fetched: false,
                installments: [],
                upcoming_installments: [],
                schedules_about_to_end: [],
                schedules_guarantees_to_update: [],
                schedules_incomplete_instructions: [],
                dateRange: {
                    from: null,
                    to: null,
                },
                smallStats: [{
                    label: 'Wszystkich pożyczek',
                    value: '0',
                    labels: ['Label', 'Label', 'Label', 'Label', 'Label', 'Label'],
                    datasets: [{
                        label: 'Today',
                        fill: 'start',
                        borderWidth: 1.5,
                        backgroundColor: 'rgba(0, 184, 216, 0.1)',
                        borderColor: 'rgb(0, 184, 216)',
                        data: [1, 2, 1, 3, 5, 4, 7],
                    }],
                }, {
                    label: 'Kwota pożyczona',
                    value: '0',
                    labels: ['Label', 'Label', 'Label', 'Label', 'Label', 'Label'],
                    datasets: [{
                        label: 'Today',
                        fill: 'start',
                        borderWidth: 1.5,
                        backgroundColor: 'rgba(23,198,113,0.1)',
                        borderColor: 'rgb(23,198,113)',
                        data: [1, 2, 3, 3, 3, 4, 4],
                    }],
                }, {
                    label: 'Szacowany przychód',
                    value: '0',
                    labels: ['Label', 'Label', 'Label', 'Label', 'Label', 'Label'],
                    datasets: [{
                        label: 'Today',
                        fill: 'start',
                        borderWidth: 1.5,
                        backgroundColor: 'rgba(255,180,0,0.1)',
                        borderColor: 'rgb(255,180,0)',
                        data: [2, 3, 3, 3, 4, 3, 3],
                    }],
                }, {
                    label: 'Przeterminowanych wpłat',
                    value: '0',
                    labels: ['Label', 'Label', 'Label', 'Label', 'Label', 'Label'],
                    datasets: [{
                        label: 'Today',
                        fill: 'start',
                        borderWidth: 1.5,
                        backgroundColor: 'rgba(255,65,105,0.1)',
                        borderColor: 'rgb(255,65,105)',
                        data: [1, 7, 1, 3, 1, 4, 8],
                    }],
                }, {
                    label: 'Najbliższe wpływy',
                    value: '0',
                    labels: ['Label', 'Label', 'Label', 'Label', 'Label', 'Label'],
                    datasets: [{
                        label: 'Today',
                        fill: 'start',
                        borderWidth: 1.5,
                        backgroundColor: 'rgb(0,123,255,0.1)',
                        borderColor: 'rgb(0,123,255)',
                        data: [3, 2, 3, 2, 4, 5, 4],
                    }],
                }],
                stats: {
                    datasets: [{
                        hoverBorderColor: '#ffffff',
                        data: [0, 0, 0],
                        backgroundColor: [
                            'rgba(0,123,255,0.9)',
                            'rgba(0,123,255,0.5)',
                            'rgba(0,123,255,0.3)',
                        ],
                    }],
                    labels: ['Wpłaty regularne', 'Spóźnienia do 30 dni', 'Spóźnienia powyżej 30 dni'],
                }
            };
        },
        methods: {
            toNumber(number){
              return Vue.toNumber(number);
            },
            fetchData(){
                axios.post('api/dashboard/get-stats', {}).then(response => {
                    let resp = response.data;
                    this.smallStats[0].value = resp.loans_number;
                    this.smallStats[1].value = this.toNumber(resp.loans_amount_sum) + ' zł';
                    this.smallStats[2].value = this.toNumber(resp.loans_final_sum) + ' zł';
                    this.smallStats[3].value = resp.delay_payments_number;
                    this.smallStats[4].value = this.toNumber(resp.upcoming_expected_payments) + ' zł';
                    this.stats.datasets[0].data[0] = resp.regular_payments;
                    this.stats.datasets[0].data[1] = resp.payment_delayed_up_to_30_days;
                    this.stats.datasets[0].data[2] = resp.payment_delayed_over_30_days;
                    this.fetched = true;
                }).catch((error) =>{
                    this.fetched = true;
                    console.log(error);
                })
            },
            loadUpcomingPayments(){
                axios.post('api/dashboard/get-upcoming-installments').then(response => {
                    this.upcoming_installments = response.data ? response.data : [];
                }).catch((errors) =>{
                    console.log(errors);
                })
            },
            loadSchedulesAboutToEnd(){
                axios.post('api/dashboard/alert').then(response => {
                    this.schedules_about_to_end = response.data ? response.data : [];
                }).catch((errors) =>{
                    console.log(errors);
                })
            },
            loadSchedulesToUpdateGuarantees(){
                axios.post('api/dashboard/get-contracts-require-operations-payment-guarantees').then(response => {
                    this.schedules_guarantees_to_update = response.data.schedules;
                }).catch((errors) =>{
                    console.log(errors);
                })
            },
            loadSchedulesIncompleteInstructions(){
                axios.post('api/dashboard/get-contracts-with-incomplete-instructions').then(response => {
                    this.schedules_incomplete_instructions = (response.data && response.data.schedules) ? response.data.schedules : [];
                }).catch((errors) =>{
                    console.log(errors);
                })
            },
        },
        mounted(){
            this.fetchData();
            this.loadUpcomingPayments();
            this.loadSchedulesAboutToEnd();
            this.loadSchedulesToUpdateGuarantees();
            this.loadSchedulesIncompleteInstructions();
        }
    };
</script>

<style>
    .stats-small--1 .stats-small__percentage{
        display: none;
    }
    .overflow-auto-dashboard .responsive-table{
        max-height: 295px;
        overflow: auto;
    }
</style>
